<template>
  <div class="list">
    <div class="ziHead">
      <img
        v-if="indexImg && indexImg !== ''"
        :src="indexImg"
        style="width: 100%; height: 100%"
      />
      <img v-else :src="indexImg2" style="width: 100%; height: 100%" />
    </div>
    <div class="ziNav">
      <div class="navMain">
        <div class="navMainLeft">
          <span
            :class="{ onActive: active == item.entTChannelUuid }"
            v-for="(item, index) in slideList"
            :key="index"
            class="spanActive"
          >
            <!-- 无三级，跳URL -->
            <!-- <a class="navMainInner" v-if=" !item.child.length && item.url && item.url !== '' && item.entTChannelUuid !== '00190007'" -->
            <a
              class="navMainInner"
              v-if="
                !item.child.length &&
                item.url &&
                item.url !== '' &&
                item.entTChannelUuid !== '02320005'
              "
              target="_blank"
              :href="item.url"
            >
              {{ item.name }}
            </a>
            <!-- 无三级，有URL ，跳本地 -->
            <!-- <a class="navMainInner" v-if=" (!item.child.length && (!item.url || item.url == '')) || item.entTChannelUuid !== '00190007'" -->
            <a
              class="navMainInner"
              v-if="
                (!item.child.length && (!item.url || item.url == '')) ||
                item.entTChannelUuid !== '02320005'
              "
              :href="
                item.catalog === 1
                  ? `/listPage/${item.entTChannelUuid}`
                  : item.catalog === 2
                  ? `/list/${item.entTChannelUuid}`
                  : `/list/${item.entTChannelUuid}`
              "
            >
              {{ item.name }}
            </a>
            <!-- 特殊情况，有三级，为大事记，跳大事记板块 -->
            <!-- <a class="navMainInner" v-if="item.child.length && item.entTChannelUuid == '00190007'" -->
            <a
              class="navMainInner"
              v-if="item.child.length && item.entTChannelUuid == '02320005'"
              href="/memorabilia/02320005"
            >
              {{ item.name }}
            </a>
            <!-- 有三级 -->
            <!-- <a class="navMainInner" v-if=" item.child.length && (!item.child[0].url || item.child[0].url == '') && item.entTChannelUuid !== '00190007'"  -->
            <a
              class="navMainInner"
              v-if="
                item.child.length &&
                (!item.child[0].url || item.child[0].url == '') &&
                item.entTChannelUuid !== '02320005'
              "
              style="background-color: blue"
              :href="
                item.child[0].catalog === 1
                  ? `/listPage/${item.child[0].entTChannelUuid}`
                  : item.child[0].catalog === 2
                  ? `/list/${item.child[0].entTChannelUuid}`
                  : `/list/${item.child[0].entTChannelUuid}`
              "
            >
              {{ item.name }}
            </a>
            <!-- <a class="navMainInner"
              v-if="item.child.length && (!item.child[0].url || item.child[0].url == '') && item.entTChannelUuid =='011500050003' " 
              :href="`/list/011500050003`">
              {{item.name}}
            </a> -->
          </span>
        </div>
        <div class="navMainRight">
          <div style="float: right">
            <span>
              <router-link to="/">
                <i class="iconfont">&#xe689;</i>
                <span> &nbsp; 首页 &nbsp;>&nbsp; </span>
              </router-link>
            </span>
            <span v-if="viewSlideHdParent" class="txt1"
              ><a :href="slideHdParentUrl">{{ slideHdParentName }}</a>
            </span>
            <span v-if="slideHdName2 != ''" class="txt2">
              &nbsp;>&nbsp; {{ slideHdName2 }}
            </span>
            <span v-if="isthird" class="txt3">&nbsp; > {{ slideHdName1 }}</span>
          </div>
        </div>
      </div>
    </div>
    <div style="clear: both"></div>
    <div class="listMain">
      <div class="listContainer">
        <!-- 导航条 -->
        <ul class="navs" :class="navBarFixed == true ? 'navBoxactive' : 'navs'">
          <a
            href="javascript:void(0)"
            v-for="(item, index) in yearList"
            :key="index"
            @click="goAnchor('year' + item.name)"
            >{{ item.name }}</a
          >
        </ul>
        <ul class="newList">
          <div
            v-for="(item, index) in yearList"
            :key="index + 'f'"
            :id="'year' + item.name"
          >
            <div class="yearname">{{ item.name }}</div>
            <div
              v-for="(item1, index1) in allArticle"
              :key="index1"
              v-show="item.entTChannelUuid == item1[0].entTChannelUuid"
            >
              <li v-for="(item2, index2) in item1" :key="index2">
                <!-- <li> -->
                <div class="time fl">
                  <p>{{ dayjs(item2.publishDate).format("M月") }}</p>
                </div>
                <div class="decoration fl">
                  <p class="line"></p>
                  <p class="row">_</p>
                </div>
                <div class="inner fr">
                  <!-- <h3 class="single-line">{{ item1.title }}</h3> -->
                  <h3 class="single-line">{{ item2.title }}</h3>
                </div>
              </li>
            </div>
          </div>
        </ul>
        <!-- <div class="pagin">
          <el-pagination background layout="prev, pager, next"
            :current-page="pageNum"
            :page-size="pageSize"
            :total="total"
            @current-change="currentChange">
          </el-pagination>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
// import {getChildChannel,getChannelInfo,articles, getAllArtListByParentUuid} from '@/api/common'
import { getChildChannel, getChannelInfo, articles } from "@/api/common";
export default {
  props: {},
  data() {
    return {
      indexImg2: require("../assets/image/partyBuilding.jpg"),
      istwo: true,
      isthird: false,
      yearList: [], //接口年分uuid
      yearList1: [], //接口年分uuid
      dataList: [], //article接口传参
      allArticle: [], 
      listDatatest: [],
      slideHdName1: "",
      slideHdName2: "",
      slideHdTitle: "",
      viewSlideHdParent: true,
      slideHdParentName: "",
      slideHdParentUrl: "",
      slideHdName: "",
      pageCont: "",
      active: "",
      slideHd: {},
      slideList: [],
      mergelist: "",
      pageSize: 10,
      pageNum: 1,
      total: 0,
      indexImg: "",
      navBarFixed: false, //导航吸顶
    };
  },
  mounted() {
    var _this = this;
    _this.active = _this.$route.params.id;
    _this.getChannelInfo();
    // 事件监听滚动条
    window.addEventListener("scroll", this.scrollnav);
    _this.test();
    _this.articlesAll();
  },
  destroy() {
    // 必须移除监听器，不然当该vue组件被销毁了，监听器还在就会出错
    window.removeEventListener('scroll', this.scrollnav)
  },
  filters: {
    ellipsis: function (value) {
      if (!value) return "";
      if (value.length > 150) {
        return value.slice(0, 150) + "...";
      }
      return value;
    },
  },
  methods: {
    // 左侧查询二级栏目
    getChildChannel(id) {
      var _this = this;
      let data = {
        applicationUuid: _this.webId,
        // applicationUuid: _this.webIdGroup,
        parentUuid: id,
      };
      getChildChannel(data).then((res) => {
        const { code, data } = res;
        if (code === 1 && data) {
          _this.slideList = data;
          // console.log(_this.slideList,88888)
          if (_this.slideList.length) {
            _this.viewSlideHdParent = true;
            let url = "";
            if (_this.slideList[0].catalog === 1) {
              url = `/listPage/${_this.slideList[0].entTChannelUuid}`;
            } else if (_this.slideList[0].catalog === 2) {
              url = `/list/${_this.slideList[0].entTChannelUuid}`;
            } else {
              url = `/list/${_this.slideList[0].entTChannelUuid}`;
            }
            _this.slideHdParentUrl = url;
          } else {
            _this.viewSlideHdParent = false;
          }
        }
      });
    },
    // 右侧查询菜单名
    getChannelInfo() {
      var _this = this;
      let params1 = {
        channelUuid: _this.$route.params.id,
      };
      getChannelInfo(params1).then((res) => {
        const { code, data } = res;
        if (code === 1 && data) {
          if (data.parentUuid == "0") {
            _this.slideHdParentName = data.name;
            if (data.fileName && data.fileName !== "") {
              _this.indexImg = data.fileName;
            } else {
              _this.indexImg = require("../assets/image/partyBuilding.jpg");
            }
            return;
          } else {
            _this.getChildChannel(data.parentUuid);
          }
          _this.slideHdName1 = data.name;

          let params2 = {
            channelUuid: data.parentUuid,
          };
          // console.log(params2,777)
          getChannelInfo(params2).then((res) => {
            const { code, data } = res;
            if (code === 1 && data) {
              if (data.parentUuid == "0") {
                // _this.getChildChannel(data.entTChannelUuid)
                _this.slideHdParentName = data.name;
                _this.slideHdName2 = _this.slideHdName1;
                _this.slideHdTitle = _this.slideHdName2;
                if (data.fileName && data.fileName !== "") {
                  _this.indexImg = data.fileName;
                } else {
                  _this.indexImg = require("../assets/image/partyBuilding.jpg");
                }
                _this.isthird = false;
              } else {
                _this.isthird = true;
                // _this.getChildChannel(data.parentUuid)
                _this.slideHdName2 = data.name;

                let params3 = {
                  channelUuid: data.parentUuid,
                };
                getChannelInfo(params3).then((res) => {
                  const { code, data } = res;
                  if (code === 1 && data) {
                    _this.slideHdParentName = data.name;
                    _this.slideHdTitle = _this.slideHdName1;
                    // _this.indexImg = data.fileName
                    // _this.getChildChannel(data.parentUuid)
                  }
                });
              }
            }
          });
        }
      });
    },

    test() {
      var _this = this;
      let data = {
        applicationUuid: _this.webId,
        parentUuid: "02320005",
      };
      getChildChannel(data).then((res) => {
        const { code, data } = res;
        if (code === 1 && data) {
          data.forEach((element) => {
            _this.yearList.push({
              entTChannelUuid: element.entTChannelUuid,
              name: element.name,
            });
          });
        }
        _this.yearList.reverse();  //  数组倒序排列
        // console.log("yearList:接口查到的年份uuid+name", _this.yearList);
        _this.yearList.forEach((item, index) => {
          _this.dataList.push({
            entTApplicationUuid: _this.webId,
            channelUuid: item.entTChannelUuid,
            pageNum: _this.pageNum,
            pageSize: 10,
            data: index,
          });
        });
        // console.log("dataList：年份传参data", _this.dataList);
      });
    },
    articlesAll() {
      var _this = this;
      setTimeout(() => {
        _this.dataList.forEach((item) => {
          articles(item).then((res) => {
            const { code, data } = res;
            if (code === 1 && data) {
              _this.allArticle.push(data.rows);
            }
          });
        });
        // console.log("所有文章allArticle", _this.allArticle);
      }, 500);

    },

    // 分页器
    currentChange(e) {
      var _this = this;
      _this.pageNum = e;
      // _this.articles();
      _this.getmergelist();
    },
    // 导航滑动
    goAnchor(selector) {
      document.querySelector(`#${selector}`).scrollIntoView({
        behavior: "smooth",
      });
    },
    // 吸顶
    scrollnav() {
      // 滚动距离
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // 容器高度
      var offsetTop = 610.34;
      //  当滚动超过 offsetTop 时，实现吸顶效果
      if (scrollTop > offsetTop) {
        this.navBarFixed = true;
      } else {
        this.navBarFixed = false;
      }
    },
  },
};
</script>
<style>
@font-face {
  font-family: "iconfont"; /* Project id 3165120 */
  src: url("//at.alicdn.com/t/font_3165120_61xe2w37jbi.woff2?t=1644917438066")
      format("woff2"),
    url("//at.alicdn.com/t/font_3165120_61xe2w37jbi.woff?t=1644917438066")
      format("woff"),
    url("//at.alicdn.com/t/font_3165120_61xe2w37jbi.ttf?t=1644917438066")
      format("truetype");
}
.iconfont {
  font-family: "iconfont" !important;
  font-size: 22px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.1px;
  -moz-osx-font-smoothing: grayscale;
}
.list .ziHead {
  width: 100%;
  height: 417px;
  overflow: hidden;
  /* background: url(../assets/image/business2.jpg) center no-repeat; */
  background-size: 100% 100%;
}
.ziNav {
  height: 42px;
  border-bottom: 1px solid #cacaca;
  margin-top: 15px;
  width: 100% !important;
}
.navMain {
  width: 1200px;
  height: auto;
  overflow: hidden;
  margin: 0 auto;
}
.list .navMainLeft {
  width: 70%;
  float: left;
}
.spanActive {
  display: inline-block;
  padding: 0 12px;
  cursor: pointer;
  height: 42px;
  line-height: 43px;
  box-sizing: border-box;
  font-size: 17px;
}
.navMainInner {
  display: inline-block;
  /* padding: 0 10px; */
  cursor: pointer;
  height: 42px;
  line-height: 43px;
  box-sizing: border-box;
  font-size: 17px;
}
.onActive a {
  border-bottom: 2px solid #0263b2;
}
.navMainInner:hover {
  border-bottom: 2px solid #0263b2;
}
.navMainRight {
  width: 25%;
  float: right;
  overflow: hidden;
  font-size: 13px;
  color: #a2a2a2;
  margin-top: 10px;
  line-height: 24px;
}
.navMainRight span {
  float: none;
  font-size: 13px;
  color: #a2a2a2;
  vertical-align: top;
}
.navMainRight span a {
  float: none;
  font-size: 13px;
  color: #a2a2a2;
  vertical-align: top;
}
.navMainRight .textTitle {
  float: none;
  font-size: 13px;
  color: #a2a2a2;
  vertical-align: top;
}
.listContainer {
  width: 1300px;
  margin: 20px auto 0;
}
.newList {
  position: relative;
  /* right: 0; */
  left: 6%;
  width: 94%;
  background-color: rgb(244, 246, 246);
  padding: 0;
  background: url(../assets/image/bgline.jpg) repeat-y 10.5% 0;
}
.newList .yearname {
  width: 100%;
  font-size: 30px;
  font-style: italic;
  margin-left: 10%;
  padding-left: 4%;
  color: #0162b3;
  /* background-color: rgb(255, 214, 214); */
  background: url(../assets/image/mini.jpg);
  background-repeat: no-repeat;
  background-position: 0% 50%;
}
.newList li {
  width: 100%;
  height: 70px;
  overflow: hidden;
  /* border-top: 1px solid #ff0000; */
  /* margin-bottom: 20px ; */
  /* margin: 20px auto; */
}
.newList li .time {
  width: 10%;
  height: 70%;
  overflow: hidden;
  /* background-color: #ffc1c1; */
  box-sizing: border-box;
  color: #666;
  text-align: center;
}
.newList li .time p {
  height: 24px;
  overflow: hidden;
  font-size: 16px;
  line-height: 24px;
  margin-top: 14px;
  text-align: center;
}
.newList li .decoration {
  position: relative;
  width: 5%;
  height: 100%;
  text-align: center;
}
.newList li .decoration .row {
  top: -12px;
  left: -37%;
  position: absolute;
  width: 100%;
  color: #0162b3;
  font-size: 30px;
  /* font-weight: bolder; */
}
.newList li .inner {
  width: 85%;
  height: 70%;
  overflow: hidden;
  background-color: rgb(244, 246, 246);
  box-sizing: border-box;
  transition: all 0.3s linear;
  border-radius: 10px;
}
.newList li .inner h3 {
  height: 33px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  line-height: 33px;
  font-size: 14px;
  margin: 8px 0 0 20px;
}
.newList li .inner p {
  height: auto;
  overflow: hidden;
  color: #6e706d;
  font-size: 13px;
  line-height: 27px;
}
.newList li a .inner:hover {
  color: #fff;
  background-color: #0162b3;
}
.newList li .inner:hover {
  color: #fff;
  background-color: #0162b3;
}
.pagin {
  margin: 20px auto;
}
.pagin .el-pager {
  margin-right: 8px;
}
.pagin li {
  height: 30px;
}
.pagin .el-pagination {
  text-align: center;
}
/* 导航条 */
.navs {
  /* position: fixed; */
  /* top: 650px;
  left: 15%; */
  position: absolute;
  text-align: center;
  width: 80px;
  padding: 10px 0;
  background-color: rgb(244, 246, 246);
}
.navs a {
  display: block;
  padding: 0 20px;
  line-height: 40px;
  font-size: 16px;
}
/* 当导航被点亮后改变颜色 */
.navs .active {
  color: #847ec3;
  background-color: #e2e2e2;
}
/* .navBox {
  position: relative;
  top: 70px;
} */
.navBoxactive {
  position: fixed;
  top: 20px;
}

@media (max-width: 1366px) {
  .listContainer {
    width: 95%;
  }
  .newList li .inner {
    width: 85%;
  }
  .navMain {
    width: 90%;
  }
}
@media (max-width: 992px) {
  .list .ziHead {
    height: 300px;
  }
  .navMain {
    width: 95%;
  }
  .list .navMainLeft {
    width: 70%;
    white-space: nowrap;
    overflow-y: hidden;
    overflow-x: auto;
  }
  .list .navMainLeft::-webkit-scrollbar {
    display: none;
  }
  .navMainRight {
    width: 30%;
  }
  .listContainer {
    width: 96%;
  }
}
@media (max-width: 768px) {
  .list .ziHead {
    height: 150px;
  }
  .navMainRight {
    display: none;
  }
  .listContainer {
    width: 95%;
  }
  .navMain {
    width: 95%;
  }
  .list .navMainLeft {
    width: 100%;
  }
  .newList {
    background: url(../assets/image/bgline.jpg) repeat-y 15.5% 0;
  }
  .newList li .time {
    width: 13%;
  }
  .newList li .inner {
    width: 80%;
  }
  .newList li .decoration .row {
    left: 10%;
  }
  .newList .yearname {
    margin-left: 13.5%;
    padding-left: 7%;
    background-position: 0% 50%;
  }
  .navs {
    display: none;
  }
}
</style>
